import React from 'react';
import PropTypes from 'prop-types';

import {courseBuilderConstants} from '../../../../utils/races/CourseBuilderConstants';

export const LegActionCategorySelect = ({value, onChange, t}) => {

  // const buildOptions = () => {
  //   return (courseBuilderConstants(t).BYO_ACTION_CATEGORIES).map((d) => {
  //     return (
  //       <MenuItem key={d.val} value={d.val} primaryText={d.caption} className={'race-category-items'}/>
  //     )
  //   });
  // };

  // return (
  //   <SelectField
  //     className={'race-category'}
  //     style={{verticalAlign:'middle', width:130}}
  //     floatingLabelText={t('Race Category')}
  //     maxHeight={200}
  //     value={value}
  //     onChange={onChange}>
  //     <MenuItem key={0} value={0} primaryText={t('Select...')} />
  //     {buildOptions()}
  //   </SelectField>
  // );

  return null;
};

LegActionCategorySelect.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func
};



/** WEBPACK FOOTER **
 ** ./components/race/create/AddCourses/LegActionCategorySelect.js
 **/